var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.positioningData)?_c('div',{staticClass:"speech-bubbles",style:({
    top: `${_vm.positioningData.top}px`,
    left: `${_vm.positioningData.left}px`,
    width: `${_vm.positioningData.width}px`,
    height: `${_vm.positioningData.height}px`,
  })},[_c('div',{staticClass:"speech-bubbles-container"},_vm._l((_vm.data),function(bubble){return _c('WsDraggableSpeechBubble',{key:bubble.id,attrs:{"data":bubble,"type":_vm.type,"order":_vm.getOrder(Number(bubble.index)),"draggable-parts":_vm.draggableGapsSentenceParts(bubble)}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }